var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4708 10.4708C12.2104 10.7311 11.7883 10.7311 11.5279 10.4708L7.99935 6.94216L4.47075 10.4708C4.2104 10.7311 3.78829 10.7311 3.52794 10.4708C3.26759 10.2104 3.26759 9.78829 3.52794 9.52794L7.52795 5.52794C7.78829 5.26759 8.2104 5.26759 8.47075 5.52794L12.4708 9.52794C12.7311 9.78829 12.7311 10.2104 12.4708 10.4708Z",
    fill: "#005083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpActive);
export default __webpack_public_path__ + "static/media/chevron-up-active.f8f2dc6305046154370b3af5052fcccb.svg";
export { ForwardRef as ReactComponent };